﻿require('./_reply');
var con = require('./_content');

$(function () {
    $('.host-btn-follow').on('click', function () {
        var id = $(this).attr('dataid');
        followUser(id, true);
    });

    $('.host-btn-homepage').on('click', function () {
        var id = $(this).attr('dataid');
        location.href = ROOT + '/home/p?id=' + id;
    });

    $('.host-btn-picture').on('click', function () {
        if ($('.modal-pictureset-item').length > 0) {
            $('#pictureset').modal('toggle');
            return;
        }

        var id = $(this).attr('dataid');
        var data = getPicturesets(id);
        if (data && data[0] && data[0].pictures.length > 0) {
            var newlist = '';
            for (var i = 0; i < data[0].pictures.length; i++) {
                var info = data[0].pictures[i];
                if (!info.url)
                    continue;
                if (info.height > 668)
                    info.url += '?w=0&h=668&s=1';
                newlist += '<div class="modal-pictureset-item">\n' +
                    '<img src="' + info.url + '" />\n' +
                    '</div>';
            }
            $('.modal-pictureset').html(newlist);

            if ($('.modal-pictureset-item').length > 0) {
                var pagelist = '';
                for (var i = 0; i < $('.modal-pictureset-item').length; i++) {
                    pagelist += '<div class="modal-page-item">' + (i + 1) + '</div>';
                }
                $('.modal-page').html(pagelist);

                $('.modal-page-item').on('click', function () {
                    $('.modal-page-item').removeClass('selected');
                    $(this).addClass('selected');

                    var page = parseInt($(this).text()) - 1;
                    $('.modal-pictureset-item').removeClass('selected');
                    $($('.modal-pictureset-item')[page]).addClass('selected');
                });

                $('.modal-page-item')[0].click();
                $('#pictureset').modal('toggle');
            }
        }
    });

    var num = 0;
    var components = $('#info_body_components').val();
    if (components) {
        components = JSON.parse(components);
        con.setcontentinfo(components);
        var body = $('.host-content').html();
        body = con.geteditorbody(body);
        $('.host-content').html(body);
        for (var i = 0; i < $('.content-live').length; i++) {
            var id = $($('.content-live')[i]).attr('data-src');
            var urls = con.playlive(id);
            var playerid = 'player-live-' + id;
            $($('.content-live')[i]).html('<div id="' + playerid + '" number="' + num++ + '" style="width: 668px; height: 534px;"></div>');
            var play;
            startPlay(play, { urls: urls, id: playerid });
            players.push(play);
        }
        for (var i = 0; i < $('.content-video').length; i++) {
            var id = $($('.content-video')[i]).attr('data-src');
            var urls = con.playvideo(id);
            var playerid = 'player-video-' + id;
            $($('.content-video')[i]).html('<div id="' + playerid + '" number="' + num++ + '" style="width: 668px; height: 534px;"></div>');
            var ads = getVideoAds(id);
            var play;
            startPlay(play, { urls: urls, id: playerid, ads: ads });
            players.push(play);
        }
        for (var i = 0; i < $('.content-audio').length; i++) {
            var id = $($('.content-audio')[i]).attr('data-src');
            var obj = con.playaudio(id);
            if (obj == null)
                continue;
            var playerid = 'player-audio-' + id;
            $($('.content-audio')[i]).html('<div id="' + playerid + '" number="' + num++ + '" style="width: 668px; height: 50px;"></div>');
            var play;
            startAudioPlay(play, obj, playerid);
            players.push(play);
        }
    }
});
